import { __decorate, __metadata, __param } from "tslib";
import { Component, Inject, Input } from 'angular-ts-decorators';
import { ProductContextService } from 'src/Foundation/Design/app';
import template from './product-buttons.component.html';
var ProductButtonsComponent = (function () {
    function ProductButtonsComponent(productContextService) {
        this.productContextService = productContextService;
    }
    ProductButtonsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.productContextService
            .subscribe()
            .then(null, null, function (group) { _this.group = group; });
    };
    Object.defineProperty(ProductButtonsComponent.prototype, "supportPageUrl", {
        get: function () {
            if (!this.group) {
                return undefined;
            }
            return this.group.supportPageUrl + "#/#" + this.group.sku;
        },
        enumerable: false,
        configurable: true
    });
    ProductButtonsComponent.$inject = ['productContextService'];
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], ProductButtonsComponent.prototype, "salesUrlText", void 0);
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], ProductButtonsComponent.prototype, "supportUrlText", void 0);
    ProductButtonsComponent = __decorate([
        Component({
            selector: 'productButtons',
            template: template,
        }),
        __param(0, Inject('productContextService')),
        __metadata("design:paramtypes", [ProductContextService])
    ], ProductButtonsComponent);
    return ProductButtonsComponent;
}());
export { ProductButtonsComponent };
